export default __webpack_public_path__ + "static/media/RunHorseLight_1_3.a4c0ddd3.jpg";